module.exports = __webpack_public_path__ + "static/img/qhtx.abc7b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/qhtx.png
// module id = gkE5
// module chunks = 1